import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Flex } from "@mantine/core";
import { useCallback } from "react";
import { useAppSelector } from "../../hooks/redux.js";
import { getSelectedMarker } from "../../reducers/markerReducer.js";
import { useCaptureEvent } from "../../components/StyleEditorContext.js";
import { Event } from "../../constants/events.js";
import { MarkerList } from "./MarkerList.js";
import { MarkerConfig } from "./MarkerConfig.js";
export const MarkersView = ({ onViewChange }) => {
    const captureEvent = useCaptureEvent();
    const selected = useAppSelector(getSelectedMarker);
    const onClose = useCallback(() => {
        captureEvent(Event.CloseMarkersPanel);
        onViewChange("ai");
    }, [captureEvent, onViewChange]);
    return (_jsxs(Flex, { h: "100%", w: selected ? "640px" : "320px", children: [_jsx(MarkerList, { onClose: onClose }), selected && _jsx(MarkerConfig, { marker: selected })] }));
};
